/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.system-package', ['popup', 'data.security-provider']);
